import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "maquinarias",
    "maquinaria",
    "MaquinariaForm",
    "/maquinarias",
);

export default handleActions(reducers, initialState);